import { apiCallPost } from "../api"
import { apiPaths } from "../config/apiPaths";

export const addComplaintsApi = async (inputData, authHeaders) => {
  const { apiVerb = "ADD", ...rest } = inputData;

  const apiInputData = {
    ...rest,
    channel: "CRM",
    apiVerb,
  };
  try {
    const res = await apiCallPost(apiPaths.addComplaints, apiInputData, authHeaders);

    if (res.id || (res.status === "SUCCESS")) {
      return { data: res.id, status: true, msg: res.message || 'Complaint Added Successfully. Try clicking on search button to get proper result.' }
    }
    return { data: [], status: false, msg: res.msg ? res.msg : 'Error Occured Please Try Again.' };
  } catch (err) {
    return { status: false, errMsg: err.message };
  }
};

export const getComplaintDataApi = async (inputData, authHeaders) => {
  const apiInputData = { ...inputData, channel: "CRM", apiVerb: "GET" };

  try {
    const res = await apiCallPost(apiPaths.addComplaints, apiInputData, authHeaders);

    if (res.requests.length > 0) {
      return {
        data: res.requests[0],
        status: true,
        msg: res.message || 'ComplaintData fetched successfully.'
      };
    }
    return {
      data: [],
      status: false,
      msg: res.msg ? res.msg : 'No images found.'
    };
  } catch (err) {
    return { status: false, errMsg: err.message };
  }
};